import actionCreatorFactory from 'typescript-fsa';

const ac = actionCreatorFactory();

const githubActions = {
  getList: ac<any>('getList'),
};

export default githubActions;
